module.exports = __webpack_public_path__ + "static/media/85.494d2686.gif";